/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Character } from '@app/core/interfaces';
import { DataService } from '@app/core/services/api';
import { ConfigService } from '@app/core/services/config/config.service';
import { LocalStorageService, keys } from '@app/core/services/storage/local-storage.service';
import { ToastComponent } from '@app/shared/components/toast/toast.component';
import * as _ from 'lodash-es';
import { firstValueFrom, Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-create-character-modal',
  templateUrl: './create-character-modal.component.html',
  styleUrls: ['./create-character-modal.component.scss']
})
export class CreateCharacterModalComponent {
  @ViewChild(ToastComponent) wdprtoast: ToastComponent;
  @ViewChild('createCharacterModal') createCharModal: ElementRef;
  @Output() onUpdate = new EventEmitter<any>();
  @Input() isUpdate: boolean;
  @Input() character: Character;
  public characterName: any;
  public imageId: any;
  public imageVersion: any;
  public allStatus: any[] = [];
  public isContinue = false;
  public characterData = new Subject<any>();
  public isExist: boolean;
  public imageUrl: any;
  public isChecked = false;
  public iid: any;
  public version: any;
  public defaultImage = 'https://latest.cdn1.parksmedia.wdprapps.disney.com/resize/mwImage/1/90/90/75/dam/wdpro-assets/avatars/180x180/RetAvatar_180x180_Default_SignedIn.png';

  characterForm: FormGroup = this.formBuilder.group({
    characterName: [''],
    imageId: [''],
    status: [''],
  });

  constructor(
    private configService: ConfigService,
    private router: Router,
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private localService: LocalStorageService
  ) { }

  public getStatus() {
    if (this.allStatus.length === 0) {
      const status = this.localService.getData(keys.characterStatus);
      if (status && status.length > 0) {
        status.forEach((stat: any) => {
          this.allStatus.push({
            value: stat.name,
          });
        });
      }
    }
  }

  async next() {
    this.iid = this.characterForm.get('imageId').value;
    this.close(false);
    let imageUrl = '';
    const myIdBaseUrl = this.configService.getValue('externalSystemsUrls')?.Uniq?.url;

    if (myIdBaseUrl) {
      imageUrl = myIdBaseUrl;
    } else {
      imageUrl = 'http://wdprplmonapp.swna.wdpr.disney.com/plmOnImageServer/ImageStream.ashx?S=500&V=<version>&IID=<iid>';
    }

    imageUrl = _.replace(imageUrl, '<iid>', this.iid);

    if (!this.isUpdate) {
      if (this.iid && this.version) {
        const res = await firstValueFrom(this.dataService.checkImage(this.iid));
        this.imageUrl = 'data:image/jpg;base64,' + res;
      }
      const charParam = {
        characterName: this.characterForm.get('characterName').value,
        imageUrl: this.imageUrl === undefined ? this.defaultImage : this.imageUrl
      };
      await firstValueFrom(this.dataService.checkCharacter(encodeURI(charParam.characterName))).then(_res => {
        this.close(false);
        this.isExist = false;
        this.router.navigate(['/character-measurement'], { queryParams: charParam });
      })
        .catch((_err) => {
          this.isExist = true;
          this.open(false);
        });
    } else {
      const status = this.characterForm.get('status').value;
      const res = await firstValueFrom(this.dataService.checkImage(this.iid));
      this.imageUrl = !this.iid || !this.version ? this.character.mediaUrl : 'data:image/jpg;base64,' + res;
      const character = {
        character_id: this.character.characterId,
        status: status === 'initial' ? this.character.status : status,
        character_image_filename: imageUrl
      };
      await firstValueFrom(this.dataService.updateCharacterProfile(character)).then(_result => {
        this.close(true);
        this.onUpdate.emit();
        this.wdprtoast.open('Character profile updated successfully', true);
      })
        .catch((_err) => {
          this.open(false);
          this.isExist = true;
        });
    }
  }

  async checkImage() {
    this.iid = this.characterForm.get('imageId').value;
    this.isChecked = true;
    this.close(false);
    const res = await firstValueFrom(this.dataService.checkImage(this.iid));
    this.imageUrl = 'data:image/jpg;base64,' + res;
    this.open(false);
  }

  open(isUpdate: boolean) {
    this.getStatus();
    this.createCharModal.nativeElement.open = true;
    const shadow = this.createCharModal.nativeElement.shadowRoot;
    if (shadow) {
      shadow.querySelector('.header')?.removeAttribute('hidden');
      shadow.querySelector('#buttonsSeparator')?.removeAttribute('hidden');
      shadow.querySelector('#buttonsWrapper')?.removeAttribute('hidden');
    }
    if (isUpdate) {
      this.characterForm.controls['status'].setValue(this.character.status);
    }
  }

  close(clear: boolean) {
    this.isExist = false;
    this.createCharModal.nativeElement.open = false;
    if (clear) {
      this.characterForm.reset();
      this.characterForm.controls['status'].setValue('initial');
      this.imageUrl = '';
    }
  }
}
